import * as React from 'react'
import { FC, useState } from 'react'
import { useGetTemplatePreview } from '../../../../hooks/useGetTemplatePreview'

import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

const styles = {
  root: {
    width: '123px',
    height: '159px',
  },

  hidden: {
    display: 'none',
  },

  preview: {
    width: '123px',
    height: '159px',
  },
}

interface Props {
  templateId: number
}

export const TemplatePreview: FC<Props> = (props: Props) => {
  const { templateId } = props
  const preview = useGetTemplatePreview(templateId)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  return (
    <Box sx={styles.root}>
      <Skeleton
        sx={{ ...(!isLoading && styles.hidden) }}
        height={123}
        variant="rectangular"
      />
      <img
        alt="Template Preview"
        style={isLoading ? styles.hidden : styles.preview}
        onLoad={() => setIsLoading(false)}
        src={preview.templatePreview}
      />
    </Box>
  )
}

TemplatePreview.displayName = 'TemplatePreview'
